/**
 * Single Source of Truth: Personal Information & Brand Identity
 * Canonical Contact: devamitin@gmail.com
 * Canonical Handles: devamitin
 */

export const personalInfo = {
    name: 'Amit Kumar',
    brandMark: 'AMIT.DEV',
    brandMonogram: 'DA',
    logoTag: 'SYSTEMS',
    terminalPrompt: '>_ AMIT.DEV',
    title: 'Senior Backend Systems Architect & Full-Stack Engineer',
    scope: 'Lead Systems Architect • Node.js | Next.js (SSR) | React Native | Kafka | AWS',
    roles: [
        'Distributed Systems Architect',
        'Lead Full-Stack Engineer',
        'Senior Backend Engineer',
        'AI Systems & Platform Engineer',
    ],
    availability: {
        status: 'AVAILABLE',
        badgeText: 'Available for Engineering Roles & Architecture Advisory',
        isAvailable: true,
    },
    contact: {
        email: 'devamitin@gmail.com',
        phone: '+91 9852972838',
        location: 'New Delhi, India',
        calendarLink: 'https://devamit.in',
    },
    socialLinks: {
        github: {
            name: 'GitHub',
            handle: 'devamitin',
            url: 'https://github.com/devamitin',
        },
        linkedin: {
            name: 'LinkedIn',
            handle: 'devamitin',
            url: 'https://linkedin.com/in/devamitin',
        },
        twitter: {
            name: 'X (Twitter)',
            handle: 'devamitin',
            url: 'https://x.com/devamitin',
        },
        npm: {
            name: 'NPM Registry',
            handle: '~devamitin',
            url: 'https://www.npmjs.com/~devamitin',
        },
        hackerrank: {
            name: 'HackerRank',
            handle: 'devamitin',
            url: 'https://www.hackerrank.com/devamitin',
        },
        codewars: {
            name: 'Codewars',
            handle: 'devamitin',
            url: 'https://www.codewars.com/users/devamitin',
        },
    },
    bio: {
        short: 'Lead Software Engineer and Cloud Architect with 4+ years of verified production leadership delivering high-throughput systems, mobile store platforms, and open-source tooling.',
        detailed: 'Specialized in distributed microservices, low-latency client-server synchronization, and scalable dual-portal web architecture. Architected enterprise platforms for Grihseva, Phnk Networks, and the Department of Posts (AMRITPEX 2023).',
    },
};

export default personalInfo;
